(function() {
  function initAccordion(element) {
    if (!element) return;
    
    const accordionHeaders = element.querySelectorAll('.m-accordion-header');
    if (accordionHeaders.length === 0) return;

    accordionHeaders.forEach(header => {
      // Remove existing listeners to prevent duplicates
      const newHeader = header.cloneNode(true);
      header.parentNode.replaceChild(newHeader, header);
      
      newHeader.addEventListener('click', function(e) {
        e.preventDefault();
        toggleAccordion(newHeader, element);
      });
    });
  }

  function toggleAccordion(clickedHeader, container) {
    const accordionItem = clickedHeader.closest('.m-accordion-item');
    if (!accordionItem) return;
    
    const content = accordionItem.querySelector('.m-accordion-content');
    if (!content) return;
    
    const isExpanded = clickedHeader.getAttribute('aria-expanded') === 'true';
    const allHeaders = container.querySelectorAll('.m-accordion-header');

    // Close all other accordions
    if (!isExpanded) {
      allHeaders.forEach(header => {
        if (header !== clickedHeader) {
          const item = header.closest('.m-accordion-item');
          if (item) {
            const itemContent = item.querySelector('.m-accordion-content');
            const iconContainer = header.querySelector('.m-accordion-icon');
            if (itemContent) {
              header.setAttribute('aria-expanded', 'false');
              itemContent.style.display = 'none';
              itemContent.classList.remove('active');
              if (iconContainer) {
                const plusIcon = iconContainer.querySelector('.m-icon-plus');
                const minusIcon = iconContainer.querySelector('.m-icon-minus');
                if (plusIcon) plusIcon.style.display = 'block';
                if (minusIcon) minusIcon.style.display = 'none';
              }
            }
          }
        }
      });
    }

    // Toggle clicked accordion
    const iconContainer = clickedHeader.querySelector('.m-accordion-icon');
    const plusIcon = iconContainer ? iconContainer.querySelector('.m-icon-plus') : null;
    const minusIcon = iconContainer ? iconContainer.querySelector('.m-icon-minus') : null;
    
    if (isExpanded) {
      clickedHeader.setAttribute('aria-expanded', 'false');
      content.style.display = 'none';
      content.classList.remove('active');
      if (plusIcon) plusIcon.style.display = 'block';
      if (minusIcon) minusIcon.style.display = 'none';
    } else {
      clickedHeader.setAttribute('aria-expanded', 'true');
      content.style.display = 'block';
      content.classList.add('active');
      if (plusIcon) plusIcon.style.display = 'none';
      if (minusIcon) minusIcon.style.display = 'block';
    }
  }

  if (!customElements.get("m-product-details-tabs")) {
    class MProductDetailsTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Small delay to ensure DOM is fully ready
        setTimeout(() => {
          initAccordion(this);
        }, 0);

        if (window.Shopify && Shopify.designMode) {
          document.addEventListener("shopify:block:select", (event) => {
            const accordionItem = event && event.target.closest('.m-accordion-item');
            if (accordionItem && this.contains(accordionItem)) {
              const header = accordionItem.querySelector('.m-accordion-header');
              if (header) {
                toggleAccordion(header, this);
              }
            }
          });
        }
      }
    }
    customElements.define("m-product-details-tabs", MProductDetailsTabs);
  }

  // Fallback initialization for elements already in DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('m-product-details-tabs').forEach(initAccordion);
    });
  } else {
    document.querySelectorAll('m-product-details-tabs').forEach(initAccordion);
  }
})();
